// Icons Import
import { FaArrowRight } from "react-icons/fa"
import { Link } from "react-router-dom"
import React, { useState } from "react";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
// Image and Video Import
import Banner1 from "../assets/Images/banner5.mp4"
import Banner2 from "../assets/Images/banner4.mp4"
import Banner3 from "../assets/Images/banner3.mp4"
// import BannerVideo from "../assets/Images/CourseCatalyst.mp4"
// Component Imports
import Footer from "../components/Common/Footer"
import ReviewSlider from "../components/Common/ReviewSlider"
import CTAButton from "../components/core/HomePage/Button"
import CodeBlocks from "../components/core/HomePage/CodeBlocks"
import ExploreMore from "../components/core/HomePage/ExploreMore"
import HighlightText from "../components/core/HomePage/HighlightText"
import InstructorSection from "../components/core/HomePage/InstructorSection"
import LearningLanguageSection from "../components/core/HomePage/LearningLanguageSection"
import TimelineSection from "../components/core/HomePage/Timeline"
import Awards from "../components/Common/Awards"
import { fadeIn } from "../components/Common/Scroll";
import Modal from "react-modal";
import { motion } from 'framer-motion'
import { getCatalogPageData } from "../services/operations/pageAndComponntDatas";
import Course_Slider from "../components/core/Catalog/Course_Slider";
import NotesCategoryPage from "./NotesCategoryPage";
 function Home() {

  const homevideo=[
    {
      id:1,
      src:Banner2,
      
    },
    {
      id:2,
      src:Banner3,
     
    },
    {
      id:3,
      src:Banner2,
     
    },
  

  ]

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
 const [catalogPageData, setCatalogPageData] = useState(null);
  const categoryID = "65ef444d790bf671e2b691af";

    useEffect(() => {
    const fetchCatalogPageData = async () => {
        
            const result = await getCatalogPageData(categoryID,dispatch);
            setCatalogPageData(result);
            // console.log("page data",CatalogPageData);
        
    }
    if (categoryID) {
        fetchCatalogPageData();
    }
}, [categoryID])
const dispatch = useDispatch();
   
  const openModal = (videoSrc) => {
    setCurrentVideo(videoSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setCurrentVideo(null);
    setIsModalOpen(false);
  };
  return (

  <>
       {/* <div className="bg-pure-greys-150 border-2 border-pink-50 w-full h-[500px]">
       <div className=" w-[400px] h-[200px] border-white border-2 ml-10">
       <HomeSlider/>
       </div>
      
      </div> */}
      <div className="bg-pure-greys-5">
     
    
      {/* Section 1 */}
      
      <div className="relative mx-auto flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 text-white">
      
        {/* Become a Instructor Button */}
        <Link to={"/signup"}>
          <div className="group mx-auto mt-16 w-fit rounded-full bg-richblack-800 p-1 font-bold text-richblack-200 drop-shadow-[0_1.5px_rgba(255,255,255,0.25)] transition-all duration-200 hover:scale-95 hover:drop-shadow-none ">
            <div className="flex flex-row items-center gap-2 rounded-full px-10 py-[5px] transition-all duration-200 group-hover:bg-richblack-400 ">
              <p>Let's Study Together</p>
              <FaArrowRight />
            </div>
          </div>
        </Link>
      {/* heading */}
        <motion.div
                        variants={fadeIn('left', 0.1)}
                        initial='hidden'
                        whileInView={'show'}
                        viewport={{ once: false, amount: 0.1 }}
                        className='text-center text-4xl font-semibold text-richblack-600 '
                    >
                        Empower Your Future with
                        <HighlightText text={"Coding Skills"} />
                    </motion.div>
                     {/* subheading */}
                    <motion.div
                        variants={fadeIn('right', 0.1)}
                        initial='hidden'
                        whileInView={'show'}
                        viewport={{ once: false, amount: 0.1 }}
                        className=' -mt-3 w-[90%] text-center text-lg font-bold text-richblack-200 '
                    >
                        With our cutting-edge e-learning programs, you have the incredible opportunity to cultivate your coding skills at your leisure, from any corner of the globe. Unlock a treasury of invaluable resources, such as immersive hands-on projects, insightful quizzes, and invaluable personalized feedback from our expert instructors. Embrace the boundless potential of our virtual classroom and set sail on a transformative journey of technological enlightenment.
                    </motion.div>


        {/* CTA Buttons */}
        <div className="mt-8 flex flex-row gap-7">
          <CTAButton active={true} linkto={"/signup"}>
            Learn More
          </CTAButton>
          <CTAButton active={false} linkto={"/login"}>
            Book a Demo
          </CTAButton>
        </div>


        {/* Video */}
      {/* <div className="flex lg:w-[100%] ">
          {
            homevideo.map((item,index)=>{
              return( <div className="mx-3 my-7 shadow-[10px_-5px_50px_-5px] shadow-blue-200 mr-5" key={index}>
          <video
            className="shadow-[10px_10px_rgba(255,255,255)]"
            muted
            loop
            autoPlay
          >
            <source src={item.src} type="video/mp4" />
          </video>
         
        </div>)
            })
          }
      </div> */}
      
      
      

      <div className="flex flex-wrap lg:flex-nowrap lg:w-[100%]">
        {homevideo.map((item, index) => (
          <div
            className="mx-3 my-7 shadow-[10px_-5px_50px_-5px] shadow-blue-200 lg:mr-5 lg:my-7 lg:mx-3 cursor-pointer"
            key={index}
            onClick={() => openModal(item.src)}
          >
            <video
              className="shadow-[10px_10px_rgba(255,255,255)]"
              muted
              loop
              autoPlay
            >
              <source src={item.src} type="video/mp4" />
            </video>
          </div>
        ))}
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75"
        overlayClassName="fixed inset-0 bg-black bg-opacity-75"
        contentLabel="Video Modal"
      >
        <div className="relative">
          <button
            className="absolute top-0 right-0 m-4 text-white text-4xl"
            onClick={closeModal}
          >
            &times;
          </button>
          {currentVideo && (
            <video controls className="max-w-full max-h-screen">
              <source src={currentVideo} type="video/mp4" />
            </video>
          )}
        </div>
      </Modal>

       

        {/* Code Section 1  */}
        <div>
          <CodeBlocks
            position={"lg:flex-row"}
            heading={
              <div className="text-4xl font-semibold text-richblack-600">
               Develop a passion for 
                <HighlightText text={"learning new things"} /> with our online
                courses.
              </div>
            }
            subheading={
              "Our courses are designed and taught by industry experts who have years of experience in coding and are passionate about sharing their knowledge with you."
            }
            ctabtn1={{
              btnText: "Try it Yourself",
              link: "/signup",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              link: "/signup",
              active: false,
            }}
            codeColor={"text-richblack-700"}
            codeblock={`<!DOCTYPE html>\n <html lang="en">\n<head>\n<title>This is myPage</title>\n</head>\n<body>\n<h1><a href="/">Header</a></h1>\n<nav> <a href="/one">One</a> <a href="/two">Two</a> <a href="/three">Three</a>\n</nav>\n</body>`}
            backgroundGradient={<div className="codeblock1 absolute"></div>}
          />
        </div>

        {/* Code Section 2 */}
        <div>
          <CodeBlocks
            position={"lg:flex-row-reverse"}
            heading={
              <div className="w-[100%] text-4xl font-semibold lg:w-[50%] text-richblack-600">
                Start
                <HighlightText text={"coding in seconds"} />
              </div>
            }
            subheading={
              "Go ahead, give it a try. Our hands-on learning environment means you'll be writing real code from your very first lesson."
            }
            ctabtn1={{
              btnText: "Continue Lesson",
              link: "/signup",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              link: "/signup",
              active: false,
            }}
            codeColor={"text-blue-200"}
            codeblock={`import React from "react";\n import CTAButton from "./Button";\nimport TypeAnimation from "react-type";\nimport { FaArrowRight } from "react-icons/fa";\n\nconst Home = () => {\nreturn (\n<div>Home</div>\n)\n}\nexport default Home;`}
            backgroundGradient={<div className="codeblock2 absolute"></div>}
          />
        </div>

          <div className=' mx-auto box-content w-full max-w-maxContentTab px-2 py-12 lg:max-w-maxContent  '>
        <h2 className='section_heading mb-6 md:text-3xl text-xl mx-auto text-center inline-block border-b-4 border-blue-50'>
           Most Popular Courses
        </h2>
        
        <Course_Slider
            Courses={catalogPageData?.data?.selectedCategory?.courses}
          />
      </div>       
        <div className=' mx-auto box-content w-full max-w-maxContentTab px-2 py-12 lg:max-w-maxContent'>
        <h2 className='section_heading mb-6 md:text-3xl text-xl mx-auto text-center inline-block border-b-4 border-blue-50'>
           Students are learning
        </h2>
        <Course_Slider
            Courses={catalogPageData?.data?.differentCategory?.courses}
          />
        
      </div>  
<NotesCategoryPage></NotesCategoryPage>
        {/* Explore Section */}
        <ExploreMore />
      </div>

      {/* Section 2 */}
      <div className="bg-pure-greys-50 text-richblack-700">
        <div className="homepage_bg h-[320px]">
          {/* Explore Full Catagory Section */}
          <div className="mx-auto flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8">
            <div className="lg:h-[150px]"></div>
            <div className="flex flex-row gap-7 text-white lg:mt-8">
              <CTAButton active={true} linkto={"/signup"}>
                <div className="flex items-center gap-2">
                  Explore Full Course
                  <FaArrowRight />
                </div>
              </CTAButton>
              <CTAButton active={false} linkto={"/login"}>
                Learn More
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="mx-auto flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 ">
          {/* Job that is in Demand - Section 1 */}
          <div className="mb-10 mt-[-100px] flex flex-col justify-between gap-7 lg:mt-20 lg:flex-row lg:gap-0">
            <div className="text-4xl font-semibold lg:w-[45%] ">
              Get the skills you need for a{" "}
              <HighlightText text={"job that is in demand."} />
            </div>
            <div className="flex flex-col items-start gap-10 lg:w-[40%]">
              <div className="text-[16px] text-richblack-500">
                The moder Course Catalyst is the dictates its own terms. Today, to
                be a competitive specialist requires more than professional
                skills.
              </div>
              <CTAButton active={true} linkto={"/signup"}>
                <div className="">Learn More</div>
              </CTAButton>
            </div>
          </div>

          {/* Timeline Section - Section 2 */}
          <TimelineSection />

          {/* Learning Language Section - Section 3 */}
          <LearningLanguageSection />
        </div>
      </div>

      {/* Section 3 */}
      <div className="relative mx-auto my-20 flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 bg-pure-greys-5 text-white">
        {/* Become a instructor section */}
        <InstructorSection />


{/* Awards Section */}
        <div className="bg-richblack-100 w-full rounded-xl">
        <h1 className="text-center text-4xl font-semibold mt-8 text-richblack-800">
         Awards And Recognization
        </h1>
     <Awards/>
        </div>
   
        {/* Reviws from Other Learner */}
        <div className="relative mx-auto my-20 flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 bg-pure-greys-150 text-white rounded-xl ">
        {/* Reviws from Other Learner */}
        <h1 className="text-center text-4xl font-semibold mt-8">
          Reviews from other learners
        </h1>
        <ReviewSlider />
      </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  </>
  )
}

export default Home
